import {BrowserModule} from '@angular/platform-browser';
import {NgModule, ApplicationRef} from '@angular/core';
import {ChartModule, HIGHCHARTS_MODULES} from 'angular-highcharts';
// import * as exporting from 'highcharts/modules/exporting';

import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {AlertService, AuthenticationService, CommonService} from './_services';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {AgmCoreModule} from '@agm/core';
import {AgmJsMarkerClustererModule} from '@agm/js-marker-clusterer';

import {DashboardComponent} from './dashboard/dashboard.component';
import {HeaderComponent} from './header/header.component';
import {PageTitleComponent} from './page-title/page-title.component';
import {FooterComponent} from './footer/footer.component';
import {IndustryCardViewComponent} from './industry-card-view/industry-card-view.component';
import {IndustryListComponent} from './industry-list/industry-list.component';
import {ReportListComponent} from './report-list/report-list.component';
import {AllIndustryMapComponent} from './all-industry-map/all-industry-map.component';
import {ReportCardViewComponent} from './report-card-view/report-card-view.component';
import {IndustryAreaChartComponent} from './industry-area-chart/industry-area-chart.component';
import {IndustryLineChartComponent} from './industry-line-chart/industry-line-chart.component';
import {LoginComponent} from './login/login.component';
import {LoginHeaderComponent} from './login-header/login-header.component';
import {IndustryComponent} from './industry/industry.component';
import {IndustryProfileCardComponent} from './industry-profile-card/industry-profile-card.component';
import {
  AllStationDeviceWiseIndustryProfileComponent
} from './all-station-device-wise-industry-profile/all-station-device-wise-industry-profile.component';
import {CemsComponent} from './cems/cems.component';
import {ReportComponent} from './report/report.component';
import {SmsReportListComponent} from './sms-report-list/sms-report-list.component';
import {ExceedanceReportListComponent} from './exceedance-report-list/exceedance-report-list.component';
import {CloseReportListComponent} from './close-report-list/close-report-list.component';
import {ExportIndustryComponent} from './export-industry/export-industry.component';
import {IndustryStatusPipe} from './industry-status.pipe';
import {ManagementComponent} from './management/management.component';
import {PublicComponent} from './public/public.component';
import {ParameterSplitPipe} from './parameter-split.pipe';
import {IndustryPublicViewComponent} from './industry-public-view/industry-public-view.component';
import {SlideShowComponent} from './slide-show/slide-show.component';
import {ManageOfficeDetailsComponent} from './manage-office-details/manage-office-details.component';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {TimepickerModule} from 'ngx-bootstrap/timepicker';
import {CountToModule} from 'angular-count-to';
import {LeastPerformingIndustryComponent} from './least-performing-industry/least-performing-industry.component';
import {MostClosedIndustryComponent} from './most-closed-industry/most-closed-industry.component';
import {VenodrWithMaxClosedIndustryComponent} from './venodr-with-max-closed-industry/venodr-with-max-closed-industry.component';
import {IndustryEditComponent} from './industry-edit/industry-edit.component';
import {Base64Pipe} from './base64.pipe';
import {UpdateStationDetailComponent} from './update-station-detail/update-station-detail.component';
import {UpdateDeviceDetailComponent} from './update-device-detail/update-device-detail.component';
import {UpdateParameterDetailComponent} from './update-parameter-detail/update-parameter-detail.component';
import {AddDetailsExistingIndustryComponent} from './add-details-existing-industry/add-details-existing-industry.component';

import {GooglePlaceModule} from 'ngx-google-places-autocomplete';
import {AboutUsComponent} from './about-us/about-us.component';
import {PublicSlideShowComponent} from './public-slide-show/public-slide-show.component';
import {CloseReportComponent} from './close-report/close-report.component';
import {ArchiveIndustryComponent} from './archive-industry/archive-industry.component';
import {GeneralDailyReportComponent} from './general-daily-report/general-daily-report.component';
import {ExceedanceDailyReportComponent} from './exceedance-daily-report/exceedance-daily-report.component';
import {OfflineDailyReportComponent} from './offline-daily-report/offline-daily-report.component';
import {DelayDailyReportComponent} from './delay-daily-report/delay-daily-report.component';
import {StationParameterReportComponent} from './station-parameter-report/station-parameter-report.component';
import {AddDetailsComponent} from './add-details/add-details.component';
import {ModalModule, BsModalService} from 'ngx-bootstrap/modal';
import {AuthInterceptor} from './_services/auth.interceptor';
import {DisableCopyPasteDirective} from './directive/appDisableCopyPaste.directive';
import { DashboardV2Component } from './dashboard-v2/dashboard-v2.component';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    HeaderComponent,
    PageTitleComponent,
    FooterComponent,
    IndustryCardViewComponent,
    IndustryListComponent,
    ReportListComponent,
    AllIndustryMapComponent,
    ReportCardViewComponent,
    IndustryAreaChartComponent,
    IndustryLineChartComponent,
    LoginComponent,
    LoginHeaderComponent,
    IndustryComponent,
    IndustryProfileCardComponent,
    AllStationDeviceWiseIndustryProfileComponent,
    CemsComponent,
    ReportComponent,
    SmsReportListComponent,
    ExceedanceReportListComponent,
    CloseReportListComponent,
    ExportIndustryComponent,
    IndustryStatusPipe,
    ManagementComponent,
    PublicComponent,
    ParameterSplitPipe,
    IndustryPublicViewComponent,
    SlideShowComponent,
    ManageOfficeDetailsComponent,
    LeastPerformingIndustryComponent,
    MostClosedIndustryComponent,
    VenodrWithMaxClosedIndustryComponent,
    IndustryEditComponent,
    Base64Pipe,
    UpdateStationDetailComponent,
    UpdateDeviceDetailComponent,
    UpdateParameterDetailComponent,
    AddDetailsExistingIndustryComponent,
    AboutUsComponent,
    PublicSlideShowComponent,
    CloseReportComponent,
    ArchiveIndustryComponent,
    GeneralDailyReportComponent,
    ExceedanceDailyReportComponent,
    OfflineDailyReportComponent,
    DelayDailyReportComponent,
    StationParameterReportComponent,
    AddDetailsComponent,
    DisableCopyPasteDirective,
    DashboardV2Component
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    ChartModule,
    CountToModule,
    NgMultiSelectDropDownModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyB-O3_aYhIgA5dPqrPjE95jNBZZ6HYni54&libraries=drawing,places,visualization'
    }),
    AgmJsMarkerClustererModule,
    GooglePlaceModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    ModalModule,

  ],
  providers: [
    // CookieService,
    AlertService,
    // { provide: HIGHCHARTS_MODULES, useFactory: () => [ exporting ] }, // add as factory to your providers
    AuthenticationService,
    CommonService,
    BsModalService,
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}

  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
